exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".displaySection,.elementContainer{content:\"\";display:table;clear:both}.displaySection{overflow:auto;padding:5px;margin:10px 10px 20px;width:96%}.elementContainer{background-color:#fff;padding:10px}.code{background-color:#f5f5f5;border:1px solid gray;font-size:.85em;padding:5px;margin-top:5px;list-style:none}.prop-list li{font-size:14px;list-style-type:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./demo/demo.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./demo/demo.scss
// module chunks = 0